// Lightweight currency / date formatters used inside react-pdf documents.
// We avoid intl in some places because react-pdf runs in the browser and can
// pick up locale; explicit formatters keep PDFs deterministic.

export function fmtCurrency(value: number | null | undefined): string {
  const n = typeof value === 'number' && isFinite(value) ? value : 0
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)
}

export function fmtNumber(value: number | null | undefined): string {
  const n = typeof value === 'number' && isFinite(value) ? value : 0
  return new Intl.NumberFormat('es-ES').format(n)
}

export function fmtPercent(value: number | null | undefined): string {
  const n = typeof value === 'number' && isFinite(value) ? value : 0
  return `${n.toFixed(1)}%`
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    const d = new Date(iso.replace(' ', 'T'))
    return new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(d)
  } catch {
    return iso ?? '—'
  }
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    const d = new Date(iso.replace(' ', 'T'))
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(d)
  } catch {
    return iso ?? '—'
  }
}

const typeLabels: Record<string, string> = {
  remove_license: 'Eliminar licencia',
  downgrade: 'Downgrade',
  disable_service: 'Deshabilitar servicio',
  reduce_purchased: 'Reducir compradas',
  remove_redundant: 'Eliminar redundante',
  alert: 'Alerta',
  alert_exchange: 'Infrautilización Exchange',
  alert_onedrive: 'Infrautilización OneDrive',
  alert_sharepoint: 'Infrautilización SharePoint',
  alert_teams: 'Infrautilización Teams',
  alert_copilot: 'Copilot sin uso',
}

const severityLabels: Record<string, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  critical: 'Critica',
}

const statusLabels: Record<string, string> = {
  pending: 'Pendiente',
  applied: 'Aplicada',
  dismissed: 'Descartada',
  expired: 'Expirada',
}

export function labelType(t: string | null | undefined): string {
  return t ? (typeLabels[t] ?? t) : '—'
}

export function labelSeverity(s: string | null | undefined): string {
  return s ? (severityLabels[s] ?? s) : '—'
}

export function labelStatus(s: string | null | undefined): string {
  return s ? (statusLabels[s] ?? s) : '—'
}

export { typeLabels, severityLabels, statusLabels }
